module.exports = __webpack_public_path__ + "media/ontploffing.7919a10d.mp4";